export default __webpack_public_path__ + "static/media/youtTubeIcon.8eb9e07c.svg";